<template>
<div class="wpa_wrap">
        <iframe
            :src="iframeURL"
            frameborder="0"
            id="tencent_doc_iframe"
            class="tencent_doc_iframe"
            ref="tencentDocIframe"
            allowfullscreen
            allow="clipboard-read; clipboard-write"
            @load="handleIframeLoad"
            @error="handleIframeError"
        ></iframe>
    </div>
</template>

<script lang="ts">
import { mapActions, mapState, mapGetters } from 'vuex';
import { switchLang } from '../../utils/lang';
import { getBrowser } from '../../utils/browser';
import { clearCookieAndToLogin } from '../../login';
import { finishDocumentLoad } from '@/utils/sentry';
export default {
    name: '',
    emits: [
        'gotoFile',
        'deleteFile',
        'gotoUseTemplate',
        'saveFileFinished',
        'createCopy',
        'moveFile',
        'handleOpen'
    ],
    components: {},
    data() {
        return {};
    },
    mounted() {
        console.log('tencent doc wrap mounted', new Date().getTime());
        console.time('tencent doc 加载耗时');

        // 腾讯文档通信
        window.addEventListener('message', this.handleMessage);
    },
    unmounted() {
        window.removeEventListener('message', this.handleMessage);
    },
    computed: {
        ...mapState({
            doc_id: state => state.kbModule.doc_id,
            doc_type: state => state.kbModule.doc_type,
            doc_info: state => state.kbEditModule.doc_info,
            isKBDirExpand: state => state.kbTreeNodeModule.isKBDirExpand,
            curSelectedTreeNodes: state =>
                state.kbTreeNodeModule.curSelectedTreeNodes,
            showtype: (state: any) => state.kbModule.showtype,
            userInfo: (state: any) => state.userModule,
            wikiI18n: (state: any) => state.kbModule.wikiI18n
        }),
        isTencentDoc() {
            return (
                this.doc_type == 'PPT' ||
                this.doc_type == 'EXCEL' ||
                this.doc_type == 'WORD' ||
                this.doc_type == 'PDF' ||
                this.doc_type == 'TXT' ||
                this.doc_type == 'SMART_SHEET' ||
                this.doc_type == 'FLOW_CHART' ||
                this.doc_type == 'MIND' ||
                this.doc_type == 'BOARD'
            );
        },
        iframeURL() {
            if (this.isTencentDoc) {
                let localUrl = window.location.href;
                let source = null;
                if (localUrl.length > 0) {
                    const searchParams = new URL(localUrl).searchParams;
                    source = searchParams.get('source');
                }
                const isSourceHome = source && source === 'home';
                if (
                    getBrowser().isInTocaApp === true &&
                    isSourceHome === true
                ) {
                    // PC 端内打开并且参数携带 source=home 时连接上 wikiHome
                    return `${
                        import.meta.env.VITE_APP_GATE_WAY_URL
                    }/cloud?fid=${this.doc_id}&source=wikiHome&showtype=${
                        this.showtype
                    }&lang=${this.wikiI18n}`;
                } else {
                    return `${
                        import.meta.env.VITE_APP_GATE_WAY_URL
                    }/cloud?fid=${this.doc_id}&source=wiki&showtype=${
                        this.showtype
                    }&lang=${this.wikiI18n}`;
                }
            } else {
                return ``;
            }
        }
    },
    methods: {
        ...mapActions({
            setKBDirExpand: 'kbTreeNodeModule/setKBDirExpand'
        }),
        handleIframeLoad() {
            console.timeEnd('tencent doc 加载耗时');
        },
        handleIframeError() {
            finishDocumentLoad('error', this.doc_id, this.doc_type);
        },

        handleMessage(event) {
            console.log('----------------kb', event);
            if (!this.isTencentDoc) return;
            const iframe = this.$refs.tencentDocIframe;
            if (!iframe || event.source !== iframe.contentWindow) return;
            const iframeOrigin = new URL(this.iframeURL, window.location.href).origin;
            if (event.origin !== iframeOrigin) return;
            const message = event.data;
            if (message?.type === 'firstScreen' || message?.eventType === 'firstScreen') {
                const payload = message.data || message;
                // A previous Tencent document can finish after the user has switched.
                if (payload.fileId && String(payload.fileId) !== String(this.doc_id)) return;
                if (payload.contentType && payload.contentType !== this.doc_type) return;
                debugger;
                finishDocumentLoad(
                    'success',
                    payload.fileId || this.doc_id,
                    payload.contentType || this.doc_type,
                    Number(payload.timestamp),
                    payload.navigation
                );
                return;
            }
            if (message === 'expandKBDir') {
                this.setKBDirExpand(true);
            } else if (message === 'starFile') {
                this.curSelectedTreeNodes.star = true;
            } else if (message === 'unstarFile') {
                this.curSelectedTreeNodes.star = false;
            } else if (message === 'createCopy') {
                this.$emit('createCopy', {
                    ...this.doc_info,
                    ...this.doc_info.fileInfo
                });
            } else if (message.type === 'saveFileFinished') {
                this.$emit('saveFileFinished', message.data);
            } else if (message === 'moveFile') {
                this.$emit('moveFile', {
                    ...this.doc_info,
                    ...this.doc_info.fileInfo
                });
            } else if (message.type === 'gotoFile') {
                let fileId = message.fileId;
                if (fileId) {
                    this.$emit('gotoFile', fileId);
                }
            } else if (message.type === 'deleteFile') {
                let fileId = message.fileId;
                if (fileId) {
                    this.$emit('deleteFile', fileId);
                }
            } else if (message.type === 'switchLang') {
                switchLang(message.data);
            } else if (message === 'logout') {
                clearCookieAndToLogin(true);
                console.log('退出登录');
            } else if (message === 'home-close') {
                window.close();
            } else if (message.type === 'gotoUseTemplate') {
                let templateId = message.templateId;
                this.$emit('gotoUseTemplate', templateId);
            } else if (message === 'handleOpen') {
                this.$emit('handleOpen');
            }
        },
        sendMessageToTencentDoc(message) {
            let src = this.$refs.tencentDocIframe.src;
            if (src.includes('cloud')) {
                let iframeWindow = this.$refs.tencentDocIframe.contentWindow;
                if (iframeWindow) {
                    iframeWindow.postMessage(message, this.iframeURL);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.wpa_wrap {
    position: relative;
    flex: 1;
    display: flex;

    iframe {
        flex: 1;
    }
}
</style>
